import { render, staticRenderFns } from "./Receivement.vue?vue&type=template&id=d292d8be&scoped=true"
import script from "./Receivement.vue?vue&type=script&lang=js"
export * from "./Receivement.vue?vue&type=script&lang=js"
import style0 from "./Receivement.vue?vue&type=style&index=0&id=d292d8be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d292d8be",
  null
  
)

export default component.exports